export default __webpack_public_path__ + "error-person.4ed0782d.svg";